
import React from 'react';
import { Badge } from '../ui/badge';
import { Tag } from 'lucide-react';
import { Document } from '../../types/dataRoom';
import { getDocumentCategory } from '../../utils/documentUtils';

interface DocumentCategoryTagsProps {
  documents: Document[];
}

const DocumentCategoryTags: React.FC<DocumentCategoryTagsProps> = ({ documents }) => {
  // Group documents by category and count them
  const categoryCount = documents.reduce((acc, doc) => {
    const category = getDocumentCategory(doc.type);
    acc[category] = (acc[category] || 0) + 1;
    return acc;
  }, {} as Record<string, number>);

  const categories = Object.entries(categoryCount).sort();

  if (categories.length === 0) {
    return null;
  }

  return (
    <div className="mb-4">
      <div className="flex items-center gap-2 flex-wrap">
        <Tag className="h-3 w-4 text-gray-500" />
        <span className="text-sm font-medium text-gray-700">Document Categories:</span>
        {categories.map(([category, count]) => (
          <Badge 
            key={category} 
            variant="outline" 
            className="bg-amber-50 text-amber-700 border-amber-200"
          >
            {category}: {count}
          </Badge>
        ))}
      </div>
    </div>
  );
};

export default DocumentCategoryTags;
